import React, { Component } from 'react';
import { Divider, Feed, Label, Image } from 'semantic-ui-react';

import ulaLogo from './../images/ulaLogo.png';
import pucLogo from './../images/pucLogo.png';

export default class EducationList extends Component {
    render() {
        return (
            <Feed>
                <Feed.Event>
                    <Feed.Label style={{lineHeight: 4, width: '25%'}}>
                        <Label basic color='blue' pointing='right'>
                            Apr. 2018 - Oct. 2018
                        </Label>
                    </Feed.Label>
                    <Feed.Content>
                        <Feed.Summary>
                        <Image src={pucLogo} size='tiny' style={{ height: '3em' }} verticalAlign='middle' />
                        <a href="https://www.uc.cl/" rel="noopener noreferrer" target="_blank">Pontificia Universidad Católica de Chile</a>, Santiago de Chile - Chile
                        </Feed.Summary>
                        <Feed.Extra text>
                            Diploma in Big Data.
                        </Feed.Extra>
                    </Feed.Content>
                </Feed.Event>
                <Divider horizontal fitted style={{ paddingTop: 5}}/>
                <Feed.Event>
                    <Feed.Label style={{lineHeight: 4, width: '25%'}}>
                        <Label basic color='blue' pointing='right'>
                            Apr. 2016 - Jul. 2016
                        </Label>
                    </Feed.Label>
                    <Feed.Content>
                        <Feed.Summary>
                        <Image src={ulaLogo} size='tiny' style={{ height: '3em' }} verticalAlign='middle' /> <a href="https://ula.ve/" rel="noopener noreferrer" target="_blank">Universidad de Los Andes</a>, Mérida - Venezuela
                        </Feed.Summary>
                        <Feed.Extra text>
                            Diploma, Web Design: Strategy and Design of Digital Information
                        </Feed.Extra>
                    </Feed.Content>
                </Feed.Event>
                <Divider horizontal fitted style={{ paddingTop: 5}}/>
                <Feed.Event>
                    <Feed.Label style={{lineHeight: 4, width: '25%'}}>
                        <Label basic color='blue' pointing='right'>
                            Feb. 2009 - Dec. 2015
                        </Label>
                    </Feed.Label>
                    <Feed.Content>
                        <Feed.Summary>
                        <Image src={ulaLogo} size='tiny' style={{ height: '3em' }} verticalAlign='middle' /> <a href="https://ula.ve/" rel="noopener noreferrer" target="_blank">Universidad de Los Andes</a>, Mérida - Venezuela
                        </Feed.Summary>
                        <Feed.Extra text>
                            Graduated in Systems Engineering.
                            <Divider horizontal fitted style={{ paddingTop: 5}}/>
                            <strong>Thesis Work:</strong> <i>Development of an Application for the game creation environment by the children</i>. With this application, children can create their own games for mobile devices (iOs & Android) in 2D. (Thesis work suggested for publication by the jury / advisor).
                            <Divider horizontal fitted style={{ paddingTop: 5}}/>
                            Available in <a href="https://goo.gl/1MKJLr" rel="noopener noreferrer" target="_blank">playstore</a>.
                        </Feed.Extra>
                    </Feed.Content>
                </Feed.Event>
            </Feed>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/EducationList.js